import { render, staticRenderFns } from "./ModelFileCollection.vue?vue&type=template&id=3e9e34a2"
import script from "./ModelFileCollection.vue?vue&type=script&lang=ts"
export * from "./ModelFileCollection.vue?vue&type=script&lang=ts"
import style0 from "./ModelFileCollection.vue?vue&type=style&index=0&id=3e9e34a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports